import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchAdCategories, deleteAdCategory } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'categoryId', label: 'ID', minWidth: 50 },
  { id: 'categoryName', label: 'Category Name', minWidth: 170 },
  { id: 'description', label: 'Description', minWidth: 300 },
  {
    id: 'price',
    label: 'Price',
    minWidth: 100,
    format: (value) => (value || value === 0 ? value : '-')
  }
];

const normalizeCategory = (category) => {
  const categoryId =
    category?.categoryId ??
    category?.id;

  const categoryName =
    category?.categoryName ??
    category?.name ??
    '';

  return {
    ...category,
    id: categoryId,
    categoryId,
    categoryName
  };
};

const AdCategoryList = ({ onEdit, searchQuery = '' }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadCategories = async () => {
      setLoading(true);
      try {
        const response = await fetchAdCategories();
        if (cancelled) return;
        const data = Array.isArray(response?.data) ? response.data : [];
        setCategories(data.map(normalizeCategory));
        setError(null);
      } catch (err) {
        console.error('Error fetching ads categories:', err);
        if (!cancelled) {
          setError('Failed to load ads categories. Please try again later.');
          setCategories([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadCategories();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (category) => {
    try {
      const categoryId =
        category?.categoryId ??
        category?.id;

      await deleteAdCategory(categoryId, {
        previousData: category,
        identifier: category?.categoryName
      });
      setRefreshTrigger((prev) => prev + 1);
    } catch (err) {
      console.error('Error deleting ads category:', err);
      // eslint-disable-next-line no-alert
      alert('Failed to delete ads category. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Ads Categories
      </Typography>

      <MasterDataTable
        persistKey="adCategory"
        data={categories}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={(category) => onEdit(normalizeCategory(category))}
        onDelete={handleDelete}
        emptyMessage="No categories found. Add your first ads category!"
      />

      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default AdCategoryList;

